export default {
  name: 'lx-scam-alert-modal',
}
